import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { getAction, httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
import SelectSiteListModal from "../../SelectSiteListModal";
import SelectProductModal from "../../SelectProductModal";
import IwsUpload from '@comp/upload/IwsUpload';
import JMultiSelectTag from "../../../../components/dict/JMultiSelectTag";
import { queryDepartTreeList, queryUserTreeList } from '@/api/api';
export default {
  name: 'ProductInfoModal',
  components: {
    JMultiSelectTag: JMultiSelectTag,
    SelectSiteListModal: SelectSiteListModal,
    SelectProductModal: SelectProductModal,
    IwsUpload: IwsUpload
  },
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '资产清单表单',
      tableName: 'ea_asset_info',
      form_fields: ['supplierId', 'siteId', 'assetCode', 'sn', 'worth', 'location', 'remark', 'status', 'batchNo', 'insideNumber', 'insideName', 'deptId', 'sort'],
      form_fields_time: ['productionDate', 'purchaseDate', 'useDate', 'expiryDate'],
      car_fields: ['card', 'frame', 'engine', 'chassis', 'voucher', 'userId'],
      asset_fields: ['netWorth', 'processId', 'coding'],
      chemical_fields: ['certificateNo', 'volume', 'density'],
      attachment_fields: ['volume'],
      asset_fields_time: ['installDate', 'warrantyStart', 'warrantyEnd'],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 10
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 14
        }
      },
      labelCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 3
        }
      },
      wrapperCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 15
        }
      },
      validatorRules: {
        productId: {
          rules: [{
            required: true,
            message: '请选择产品!'
          }]
        },
        supplierId: {
          rules: [{
            required: true,
            message: '请选择供应商!'
          }]
        },
        card: {
          rules: [{
            required: true,
            message: '请输入车牌号码!'
          }]
        },
        frame: {
          rules: [{
            required: true,
            message: '请输入车架号!'
          }]
        },
        engine: {
          rules: [{
            required: true,
            message: '请输入车动机号码!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择资产状态!'
          }]
        },
        purchaseDate: {
          rules: [{
            required: true,
            message: '请选择购置日期!'
          }]
        },
        expiryDate: {
          rules: [{
            required: true,
            message: '请选择有效期至!'
          }]
        },
        voucher: {
          rules: [{
            required: true,
            message: '请输入凭证编号!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择车辆负责人!'
          }]
        },
        insideNumber: {
          rules: [{
            required: true,
            message: '请输入内部编号!'
          }]
        },
        // insideName: {rules: [{required: true, message: '请输入内部名称!'}]},
        // volume: { rules: [{ required: true, message: '请输入单位体积!' }] },
        intensity: {
          rules: [{
            required: true,
            message: '请输入浓度!'
          }]
        }
      },
      url: {
        carInfo: '/ea/asset/car',
        chemicalInfo: '/ea/asset/chemical',
        equipmentInfo: '/ea/asset/equipment',
        attachmentInfo: '/ea/asset/attachment',
        queryCompany: '/ea/company/info/queryCompanyName',
        assetInfo: '/ea/asset/info'
      },
      headers: {},
      validity: 0,
      uploadLoading: false,
      category: '',
      companyList: [],
      infourl: '',
      factorOptions: [],
      selectedSite: [],
      siteIds: [],
      selectedProduct: [],
      productIds: [],
      disableName: false,
      fields: [],
      deptTree: [],
      //部门信息
      userTree: [] //人员信息

    };
  },
  props: ['pagePath', 'danger'],
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.loadCompany(); //厂商

      this.selectedSite = [];
      this.siteIds = [];
      this.selectedProduct = [];
      this.productIds = [];
      this.model.category = this.category;
      this.loadTree(); //加载部门

      this.form_fields_time = ['productionDate', 'purchaseDate', 'useDate', 'expiryDate'];
      this.form_fields = ['supplierId', 'siteId', 'assetCode', 'sn', 'worth', 'location', 'remark', 'status', 'batchNo', 'insideNumber', 'deptId', 'insideName', 'sort']; //确定需要展示的属性以及后台请求路径

      this.fields = [];
      this.infourl = this.pagePath;

      if (this.category == 11 || this.category == 12) {
        this.fields = this.form_fields.concat(this.asset_fields);
        this.form_fields_time = this.form_fields_time.concat(this.asset_fields_time);
        this.infourl = this.url.equipmentInfo;
      } else if (this.category == 31) {
        this.loadTreeList();
        this.fields = this.form_fields.concat(this.car_fields);
        this.infourl = this.url.carInfo;
      } else if (this.category == 21 || this.category == 22 || this.category == 23) {
        this.fields = this.form_fields.concat(this.chemical_fields);
        this.infourl = this.url.chemicalInfo;
      } else if (this.category == 91 || this.category == 92) {
        this.fields = this.form_fields.concat(this.attachment_fields);
        this.infourl = this.url.attachmentInfo;
      } else {
        this.infourl = this.url.assetInfo;
        this.fields = this.form_fields;
      }

      if (this.model.id || this.showTab == false) {
        this.siteIds = this.model.siteId ? this.model.siteId : null;
        this.productIds = this.model.productId ? this.model.productId : null;
        this.selectedSite.push(this.model.siteName);
        this.selectedProduct.push(this.model.productName);
        this.loadProduct();
      } else if (!this.model.id) {
        this.model.status = '1';
        this.renderProductModel();
      }

      this.visible = true;
    },
    renderProductModel: function renderProductModel() {
      var _this = this;

      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);

        _this.$refs.SiteListModal.edit(_this.selectedSite, _this.siteIds);

        _this.$refs.ProductListModal.edit(_this.selectedProduct, _this.productIds);

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    //加载部门信息
    loadTree: function loadTree() {
      var _this2 = this;

      var that = this;
      that.deptTree = []; // 部门

      queryDepartTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.deptTree.push(temp);
          }

          _this2.loading = false;
        }
      });
    },
    loadProduct: function loadProduct() {
      var _this3 = this;

      getAction(this.infourl + '/' + this.model.id).then(function (res) {
        if (res.success) {
          _this3.model = Object.assign({}, res.result);
          _this3.model.category = _this3.category;

          _this3.renderProductModel();
        }
      });
    },
    handleOk: function handleOk() {
      var _this4 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        console.log('err', err);

        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          });

          if (_this4.showTab == false) {
            _this4.model.id = '';
            formData.logs = [];
          }

          var httpurl = _this4.infourl,
              method = '';

          if (!_this4.model.id) {
            method = 'post';
          } else {
            method = 'put';
          } // console.log(this.$refs.iwupload.getUploadList())


          formData.siteId = that.siteIds && (that.siteIds == [] || that.siteIds.length == 0) ? '' : that.siteIds;
          formData.productId = that.productIds && (that.productIds == [] || that.productIds.length == 0) ? '' : that.productIds;

          var filelist = _this4.$refs.iwupload.getUploadList();

          formData.fileDelList = filelist.fileDelList;
          formData.sysFileList = filelist.sysFileList;
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    selectSite: function selectSite() {
      this.$refs.SiteListModal.add(this.selectedSite, this.siteIds);
    },
    // 子modal回调
    choseSite: function choseSite(siteList) {
      this.selectedSite = [];
      this.siteIds = [];

      for (var i = 0; i < siteList.length; i++) {
        this.selectedSite.push(siteList[i].name);
        this.siteIds = siteList[i].id;
      }
    },
    selectProducts: function selectProducts() {
      this.$refs.ProductListModal.category = this.category;
      this.$refs.ProductListModal.danger = this.danger;
      this.$refs.ProductListModal.disableSubmit = true;
      this.$refs.ProductListModal.add(this.selectedProduct, this.productIds);
    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      this.selectedProduct = [];
      this.productIds = [];

      for (var i = 0; i < productList.length; i++) {
        this.selectedProduct.push(productList[i].name);
        this.productIds = productList[i].id;

        if (this.category == 21 || this.category == 22 || this.category == 23) {
          if (productList[i].validity) {
            this.validity = productList[i].validity;
          }

          this.model.volume = productList[i].quantity;

          if (productList[i].intensityUnit_dictText) {
            this.model.intensityUnit_dictText = productList[i].intensityUnit_dictText;
          }

          this.form.setFieldsValue({
            volume: this.model.volume
          });
          this.form.setFieldsValue({
            density: productList[i].intensity
          });
        }

        if (productList[i].unit_dictText) {
          this.model.unit_dictText = productList[i].unit_dictText;
        }
      }
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this5 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this5.loading = false;
        }
      });
    },
    changeExpiryDate: function changeExpiryDate(value) {
      if (this.validity != 0) {
        var oldExpiryDate = new Date(value.year(), value.month(), value.date());
        var newExpiryDate;
        oldExpiryDate = oldExpiryDate.setMonth(oldExpiryDate.getMonth() + this.validity);
        newExpiryDate = new Date(oldExpiryDate);
        this.form.setFieldsValue({
          expiryDate: moment(newExpiryDate, 'YYYY-MM-DD')
        });
      }
    }
  }
};